import { ConfigurationTypes } from '../const/ConfigurationTypes';
import IBetConfig from './contracts/configurations/IBetConfig';
import IBuyFeatureConfig from './contracts/configurations/IBuyFeatureConfig';
import IConfiguration from './contracts/configurations/IConfiguration';
import ISceneSpineAnimConfig from './contracts/configurations/ISceneSpineAnimConfig';
import ISettingsConfig from './contracts/configurations/ISettingsConfig';
import ISpineWinSymbolViewConfig from './contracts/configurations/ISpineWinSymbolViewConfig';
import ISymbolSpineAnimConfig from './contracts/configurations/ISymbolSpineAnimConfig';
import IAdvanceGeneralGameConfig from './contracts/configurations/game/IAdvanceGeneralGameConfig';
import ILocalConfig from './contracts/configurations/ILocalConfig';
import IRelaxServerConfig from './contracts/configurations/IRelaxServerConfig';

class ConfigManager {
    private _configs: Map<ConfigurationTypes, IConfiguration> = new Map();
    private _oldConfigurationVersion = false;

    get configs(): Map<ConfigurationTypes, IConfiguration> {
        return this._configs
    }

    /**
     * Return one of the Configurations declared in ConfigurationTypes
     * @param configType one of  "ConfigurationTypes"
     */
    getConfig(configType: ConfigurationTypes.SPINE_ANIMATIONS): ISceneSpineAnimConfig;
    getConfig(configType: ConfigurationTypes.SYMBOL_SPINE_ANIMATIONS): ISymbolSpineAnimConfig;
    getConfig(configType: ConfigurationTypes.BET): IBetConfig;
    getConfig(configType: ConfigurationTypes.SETTINGS): ISettingsConfig;
    getConfig(configType: ConfigurationTypes.LOCAL): ILocalConfig;
    getConfig<T>(configType: ConfigurationTypes.GAME): IAdvanceGeneralGameConfig<T>;
    getConfig(configType: ConfigurationTypes.RELAX_SERVER): IRelaxServerConfig;
    getConfig(configType: ConfigurationTypes.WIN_SYMBOL_SPINE_ANIMATIONS): ISpineWinSymbolViewConfig;
    getConfig(configType: ConfigurationTypes.BUY_FEATURE): IBuyFeatureConfig;
    public getConfig(configType: ConfigurationTypes): IConfiguration {
        let result = null;
        if (this.configs.has(configType)) {
            result = this.configs.get(configType)
        } else {
            console.warn(
                `[CONFIGURATION MANAGER] -> configuration with type: <${configType}>, has not a registered in ConfigManager`,
                {
                    registeredConfigurations: this.configs.keys()
                }
            );
        }

        return result
    }
    private setConfig(configType: ConfigurationTypes, config: IConfiguration): void {
        if (this.configs.has(configType)) {
            console.warn(
                `[CONFIGURATION MANAGER] -> configuration with type:  <${configType}>, already registered in ConfigManager`,
                this.configs.get(configType)
            );
        } else {
            this.configs.set(configType, config)
        }
    }

    public registerConfigs(data: IConfiguration[]): void {
        data.forEach(config => {
            this.setConfig(config.type, config)
        })
    }
}

export default new ConfigManager()
